import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'

import {
  BotaoStep,
  Carregando,
  scrollParaTopo,
  WizardContainer
} from 'src/componentes'
import { FuncoesMoeda } from 'src/componentes/funcoes'
import { Api } from 'src/servicos'

import {
  ModalSucessoSolicitacaoRescisao,
  ModalSucessoSolicitacaoRescisaoRef
} from '../../componentes/modal-sucesso-solicitacao'
import RescisaoContainer from '../../container'
import { CaixaValores, ContainerAcoes, ContainerConteudo } from '../../styles'

/**
 * TELA 2 — Cláusula penal e valores (§3 da PROPOSTA).
 * Vem depois da TELA 3 (Dados) no wizard: o backend só calcula os valores
 * depois que a Matricula é vinculada ao protocolo. O CONTEÚDO é condicional:
 * valores calculados quando há saldo a vencer, ou texto alternativo quando o
 * curso está quitado.
 */
export const EtapaValores: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const { protocolo, valores, definirValores } = RescisaoContainer.useContainer()
  const { voltarWizard } = WizardContainer.useContainer()
  const [carregando, definirCarregando] = useState(true)
  const [concluindo, definirConcluindo] = useState(false)
  const modalSucessoRef = useRef<ModalSucessoSolicitacaoRescisaoRef>(null)

  useEffect(() => {
    scrollParaTopo()

    const carregar = async () => {
      try {
        definirCarregando(true)
        const dados = await Api.ObterValoresRescisaoAluno(id)
        definirValores(dados)
      } catch (error) {
        console.error('Erro ao carregar valores da rescisão:', error)
      } finally {
        definirCarregando(false)
      }
    }

    if (!valores) carregar()
    else definirCarregando(false)
  }, []) //eslint-disable-line

  const avancar = async () => {
    try {
      definirConcluindo(true)
      await Api.ConcluirSolicitacaoRescisao(id)
      modalSucessoRef.current?.abrir(protocolo?.numeroProtocolo)
    } finally {
      definirConcluindo(false)
    }
  }

  if (carregando) {
    return <Carregando texto="Carregando valores da rescisão..." />
  }

  if (!valores) {
    return (
      <ContainerConteudo>
        <h2>Cláusula penal e valores</h2>
        <p>
          Não foi possível carregar os valores da rescisão. Tente novamente
          mais tarde.
        </p>
      </ContainerConteudo>
    )
  }

  return (
    <ContainerConteudo>
      <h2>Cláusula penal e valores</h2>
      <p>
        Parágrafo Primeiro: incidirá cláusula penal em{' '}
        {valores.percentualTaxaRescisao}% sobre as parcelas ainda não vencidas
        do curso contratado, além dos eventuais valores inadimplentes do
        período anterior ao pedido de rescisão.
      </p>

      {valores?.cursoQuitado ? (
        <p>
          Como seu curso já foi quitado, os valores rescisórios serão
          apresentados diretamente pelo especialista que realizar o atendimento
          do seu protocolo.
        </p>
      ) : (
        <>
          <CaixaValores>
            <div className="linha">
              <span>Valor à vencer</span>
              <span>{FuncoesMoeda.formatarMoeda(valores.valoresAVencer)}</span>
            </div>
            <div className="linha">
              <span>Multa rescisória ({valores.percentualTaxaRescisao}%)</span>
              <span>{FuncoesMoeda.formatarMoeda(valores.multaRescisoria)}</span>
            </div>
            <div className="linha">
              <span>Valores pendentes</span>
              <span>
                {FuncoesMoeda.formatarMoeda(valores.valoresPendentes)}
              </span>
            </div>
            <div className="linha total">
              <span>Valor final</span>
              <span>{FuncoesMoeda.formatarMoeda(valores.totalAPagar)}</span>
            </div>
          </CaixaValores>
          {valores.multaRescisoria === 0 && valores.valoresPendentes > 0 && (
            <p>
              A multa rescisória é calculada apenas sobre parcelas ainda não
              vencidas. Como não há parcelas futuras em aberto no seu
              contrato, a multa é R$ 0,00 — porém os valores pendentes acima
              continuam sendo devidos integralmente.
            </p>
          )}
          <p>
            O valor total poderá ser pago em 1x via boleto ou em até 12x no
            cartão de crédito (comprometendo o limite total).
          </p>
        </>
      )}

      <ContainerAcoes>
        <BotaoStep
          invertido
          texto="Voltar para"
          textoNegrito="Dados da solicitação"
          tema="Secundario"
          type="button"
          onClick={() => voltarWizard()}
        />
        <BotaoStep
          texto="Concluir"
          textoNegrito="Solicitação"
          type="button"
          onClick={avancar}
          carregando={concluindo}
        />
      </ContainerAcoes>
      <ModalSucessoSolicitacaoRescisao ref={modalSucessoRef} backdrop />
    </ContainerConteudo>
  )
}
